<template>
  <div class="d-flex flex-column py-3" style="gap: 1em">
    <fccConfiguracaoDaPublicacao />

    <template v-if="configuracao">
      <fccConfiguracaoDefinidaParaPublicacao />
      <fccApresentacao :abaDesabilitada="abaDesabilitada" />
      <fccDatasEGrupos :abaDesabilitada="abaDesabilitada" />
      <fccLocalDeProvaStatus :etapa="etapa" v-if="possuiStatus" />
    </template>
  </div>
</template>

<script>
import fccConfiguracaoDaPublicacao from './fccConfiguracaoDePublicacao/fccConfiguracaoDaPublicacao.vue'
import fccConfiguracaoDefinidaParaPublicacao from './fccConfiguracaoDePublicacao/fccConfiguracaoDefinidaParaPublicacao.vue'
import fccApresentacao from './fccApresentacao/fccApresentacao.vue'
import fccDatasEGrupos from './fccDatasEGrupos/fccDatasEGrupos.vue'
import store from '../../../../store'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import { TP_ETAPA, TP_SITUACAO } from '../constantes'

export default {
  components: {
    fccConfiguracaoDaPublicacao,
    fccConfiguracaoDefinidaParaPublicacao,
    fccApresentacao,
    fccDatasEGrupos,
    fccLocalDeProvaStatus
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    listaStatus() {
      return store.state.localDeProva.listaStatus
    },
    statusAtual() {
      return store.state.localDeProva.statusAtual
    },
    abaDesabilitada() {
      const situacao = this.listaStatus?.find(
        (item) => item.tpEtapa === TP_ETAPA.CONFIGURACAO
      )?.tpSituacao
      return situacao == TP_SITUACAO.FINALIZADO || situacao == TP_SITUACAO.CANCELADO
    },
    possuiStatus() {
      return !!this.listaStatus?.find((item) => item.tpEtapa === TP_ETAPA.CONFIGURACAO)?.tpSituacao
    },
    etapa() {
      return TP_ETAPA.CONFIGURACAO
    }
  }
}
</script>